// Signapharma product catalog (static for MVP, easy to move to backend later)

const IMG = {
  neonCross:
    "https://static.prod-images.emergentagent.com/jobs/246bdc4f-04a8-499f-a35e-a2d34f82e829/images/39af0e7b3c30d73d658a5d87268fcb312ed3a7bcc94f6309c1d310c0f3943f67.png",
  inoxLetters:
    "https://static.prod-images.emergentagent.com/jobs/246bdc4f-04a8-499f-a35e-a2d34f82e829/images/6fc87e1dc042984e5c247915d78f152ab6cb8d22a8add405c4e01e3221bab027.png",
  pharmaNight:
    "https://static.prod-images.emergentagent.com/jobs/246bdc4f-04a8-499f-a35e-a2d34f82e829/images/59d53fa325aa7aab4499d0ed6b8a8bb7d0bfffb1ef42a7a2059a81c37a587546.png",
  pharmaInterior:
    "https://static.prod-images.emergentagent.com/jobs/246bdc4f-04a8-499f-a35e-a2d34f82e829/images/f73d9339a1d620ce940b09a28c6820677ab743353b87bcb8165d116221cf2724.png",
};

// GALLERY items — titres SEO fournis par le client (24 items, ordre imposé).
// Chaque titre FR contient : nom de la pharmacie, type de produit, localisation.
// Les traductions DE/EN/IT sont dérivées du FR pour préserver les mots-clés.
export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/090piegq_5c6c3b03-11f6-45e7-9420-49160210033d.jpg",
    title: {
      fr: "Enseigne lumineuse Pharmacie Helvétique 1, croix de pharmacie — lettres rétro éclairage LED — Genève",
      de: "Leuchtreklame Pharmacie Helvétique 1, Apothekenkreuz — LED-hinterleuchtete Buchstaben — Genf",
      en: "Illuminated sign Pharmacie Helvétique 1, pharmacy cross — LED backlit letters — Geneva",
      it: "Insegna luminosa Pharmacie Helvétique 1, croce farmacia — lettere retroilluminate LED — Ginevra",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/yhrmjfje_0a7c857d-8040-4883-8b84-79c243a3b208.jpg",
    title: {
      fr: "Pharmacie Helvétique 2 — lettres boîtier & croix rétro éclairage LED, enseigne drapeau — réclame lumineuse Genève",
      de: "Pharmacie Helvétique 2 — Gehäusebuchstaben & LED-Fahnenkreuz — Leuchtreklame Genf",
      en: "Pharmacie Helvétique 2 — box letters & LED backlit flag cross — illuminated sign Geneva",
      it: "Pharmacie Helvétique 2 — lettere scatolate & croce LED a bandiera — insegna luminosa Ginevra",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/wr7dk9my_CROIX%20DE%20PHARMACIE%20GENEVE.jpg",
    title: {
      fr: "Croix de pharmacie LED point à point recto-verso, animation, afficheur heure et température — Lyon Part-Dieu, Rhône",
      de: "LED-Punktmatrix-Apothekenkreuz, doppelseitig, Uhr- und Temperaturanzeige — Lyon Part-Dieu",
      en: "Dot-matrix LED pharmacy cross, double-sided, time & temperature display — Lyon Part-Dieu, France",
      it: "Croce farmacia LED punto a punto, fronte-retro, display ora e temperatura — Lyon Part-Dieu, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/j7pe01e8_enseigne%20neon%20led%20geneve.png",
    title: {
      fr: "Enseigne néon LED, croix LED — Villeurbanne, métropole de Lyon",
      de: "Neon-LED-Leuchtreklame, LED-Kreuz — Villeurbanne, Grossraum Lyon",
      en: "LED neon illuminated sign, LED cross — Villeurbanne, Lyon metropolis",
      it: "Insegna luminosa neon LED, croce LED — Villeurbanne, Lione",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/to8j2jz8_20241227_182350.jpg",
    title: {
      fr: "Pharmacie de la République — lettres boîtier lumineuses plexiglas LED — Bourg-en-Bresse, Ain",
      de: "Pharmacie de la République — leuchtende Plexiglas-Gehäusebuchstaben LED — Bourg-en-Bresse",
      en: "Pharmacie de la République — plexiglass LED box letters — Bourg-en-Bresse, France",
      it: "Pharmacie de la République — lettere scatolate LED plexiglass — Bourg-en-Bresse, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/m1m46utq_f72e592a-999f-4362-8893-6b4442dee136.png",
    title: {
      fr: "Croix de pharmacie verte, logo avec flèche directionnelle — croix recto-verso — Grenoble, Isère",
      de: "Grünes Leuchtkreuz, Logo mit Richtungspfeil — doppelseitiges Apothekenkreuz — Grenoble",
      en: "Green pharmacy cross, custom logo with directional arrow — double-sided — Grenoble, France",
      it: "Croce farmacia verde, logo con freccia direzionale — fronte-retro — Grenoble, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/d7irdn5w_20251111_150937.jpg",
    title: {
      fr: "Croix de pharmacie centre commercial — face plexiglas et éclairage LED — Annecy, Haute-Savoie",
      de: "Apothekenkreuz Einkaufszentrum — Plexiglas-Front und LED-Beleuchtung — Annecy",
      en: "Pharmacy cross shopping center — plexiglass face and LED lighting — Annecy, France",
      it: "Croce farmacia centro commerciale — fronte plexiglass e illuminazione LED — Annecy, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/4i8bf35f_20260119_174559.jpg",
    title: {
      fr: "Croix de pharmacie design, personnalisée, rétro-éclairage LED — Chambéry, Savoie",
      de: "Design-Apothekenkreuz, individuell, LED-hinterleuchtet — Chambéry",
      en: "Design pharmacy cross, custom, LED backlit — Chambéry, France",
      it: "Croce farmacia design, personalizzata, retroilluminazione LED — Chambéry, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/zr2clqu5_20260218_144559.jpg",
    title: {
      fr: "Croix moderne personnalisée vert pomme, pose sur façade — croix de pharmacie Roanne, Loire",
      de: "Moderne apfelgrüne Kreuz, Fassadenmontage — Apothekenkreuz Roanne",
      en: "Modern apple green custom cross, facade mount — pharmacy cross Roanne, France",
      it: "Croce moderna verde mela personalizzata, facciata — croce farmacia Roanne, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/4zk0hhms_224cf063-285f-43f5-a67f-d4a06daac704.png",
    title: {
      fr: "Pharmacie Place Bellecour — caisson lettres lumineuses, tôle aluminium LED — Lyon 2e",
      de: "Pharmacie Place Bellecour — Buchstabenkasten, Aluminiumblech LED — Lyon 2e",
      en: "Pharmacie Place Bellecour — illuminated letter box, aluminum sheet LED — Lyon 2nd district",
      it: "Pharmacie Place Bellecour — cassone lettere luminose alluminio LED — Lione 2°",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/kx61tf0r_Capture%20d%E2%80%99%C3%A9cran%202026-05-03%20213630.png",
    title: {
      fr: "Croix pharmacie néon LED sur plexiglas — Saint-Étienne, Loire",
      de: "Apotheken-Neon-LED-Kreuz auf Plexiglas — Saint-Étienne, Loire",
      en: "LED neon pharmacy cross on plexiglass — Saint-Étienne, France",
      it: "Croce farmacia neon LED su plexiglass — Saint-Étienne, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/gvrfwdaz_Capture%20d%E2%80%99%C3%A9cran%202026-05-03%20214416.png",
    title: {
      fr: "Logo pharmacie relief vert pomme et blanc, éclairage LED, face plexiglas — Valence, Drôme",
      de: "Apotheken-Relieflogo apfelgrün und weiss, LED-Beleuchtung, Plexiglas-Front — Valence",
      en: "Apple green and white 3D relief pharmacy logo, LED lighting, plexiglass face — Valence, France",
      it: "Logo farmacia rilievo verde mela e bianco, LED, fronte plexiglass — Valence, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/f4xzlnoe_Capture%20d%E2%80%99%C3%A9cran%202026-05-03%20214525.png",
    title: {
      fr: "Lettres lumineuses face vert pomme, éclairage LED — Vienne, Isère",
      de: "Leuchtbuchstaben apfelgrüne Front, LED-Beleuchtung — Vienne, Isère",
      en: "Apple green face illuminated letters, LED lighting — Vienne, France",
      it: "Lettere luminose fronte verde mela, LED — Vienne, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/z9sydt4o_Capture%20d%E2%80%99%C3%A9cran%202026-05-03%20214650.png",
    title: {
      fr: "Croix lumineuse plexiglas, croix de pharmacie vert moyen, logo personnalisé — Aix-les-Bains, Savoie",
      de: "Plexiglas-Leuchtkreuz, mittelgrünes Apothekenkreuz, individuelles Logo — Aix-les-Bains",
      en: "Plexiglass illuminated cross, medium green pharmacy cross, custom logo — Aix-les-Bains, France",
      it: "Croce luminosa plexiglass, croce farmacia verde medio, logo personalizzato — Aix-les-Bains, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/2ohf2zsr_H124303cd3a8b4179912909550d95e158o.jpg",
    title: {
      fr: "Logo plexiglas design, croix de pharmacie lumineuse, éclairage LED — Thonon-les-Bains, Haute-Savoie",
      de: "Plexiglas-Designlogo, leuchtendes Apothekenkreuz, LED — Thonon-les-Bains",
      en: "Design plexiglass logo, illuminated pharmacy cross, LED — Thonon-les-Bains, France",
      it: "Logo plexiglass design, croce farmacia luminosa, LED — Thonon-les-Bains, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/c6nfq7lt_Hd6eddaf76e1f40068c2b5ef1da510808s.jpg",
    title: {
      fr: "Détail croix de pharmacie plexiglas LED, logo vert moyen — Bourgoin-Jallieu, Isère",
      de: "Detail Apotheken-Plexiglaskreuz LED, mittelgrünes Logo — Bourgoin-Jallieu",
      en: "Plexiglass LED pharmacy cross detail, medium green logo — Bourgoin-Jallieu, France",
      it: "Dettaglio croce farmacia plexiglass LED, logo verde medio — Bourgoin-Jallieu, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/0sdc76ba_Hf32feac546c941168e9262a347193caau.jpg",
    title: {
      fr: "Croix de pharmacie néon LED sur plexiglas, croix personnalisée — Ambérieu-en-Bugey, Ain",
      de: "Neon-LED-Apothekenkreuz auf Plexiglas, individuell — Ambérieu-en-Bugey",
      en: "LED neon pharmacy cross on plexiglass, custom — Ambérieu-en-Bugey, France",
      it: "Croce farmacia neon LED su plexiglass, personalizzata — Ambérieu-en-Bugey, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/9oyw7ujb_71fg0TayP-L.jpg",
    title: {
      fr: "Croix de pharmacie néon LED, caducée-croix personnalisée — Divonne-les-Bains, pays de Gex",
      de: "Neon-LED-Apothekenkreuz, individueller Caduceus-Kreuz — Divonne-les-Bains",
      en: "LED neon pharmacy cross, custom caduceus-cross — Divonne-les-Bains, France",
      it: "Croce farmacia neon LED, caduceo-croce personalizzato — Divonne-les-Bains, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/t5z6y1r9_H1ac437fdeb144ecfb170eee43fe1b860F.jpg",
    title: {
      fr: "Croix personnalisée, logo de pharmacie, LED vert et bleu, plexiglas — Oyonnax, Haut-Bugey",
      de: "Individuelles Kreuz, Apotheken-Logo, LED grün und blau, Plexiglas — Oyonnax",
      en: "Custom cross, pharmacy logo, green and blue LED, plexiglass — Oyonnax, France",
      it: "Croce personalizzata, logo farmacia, LED verde e blu, plexiglass — Oyonnax, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/uj14canw_H2dd4f25313a84e1b836e1038a1ab471eF.jpg",
    title: {
      fr: "Enseigne drapeau lumineuse, croix de pharmacie, face plexiglas vert LED — Ferney-Voltaire, pays de Gex",
      de: "Fahnenreklame, Apothekenkreuz, grüne Plexiglas-Front LED — Ferney-Voltaire",
      en: "Illuminated flag sign, pharmacy cross, green plexiglass face LED — Ferney-Voltaire, France",
      it: "Insegna a bandiera luminosa, croce farmacia, fronte plexiglass verde LED — Ferney-Voltaire, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/wwt4jqmd_Ha3cf978cb0234142b05692ee393030f3V.png",
    title: {
      fr: "Logo croix de pharmacie personnalisé, sur mesure, design — Gex, pays de Gex, Ain",
      de: "Individuelles Apothekenkreuz-Logo, massgeschneidert, Design — Gex",
      en: "Custom pharmacy cross logo, bespoke, design — Gex, France",
      it: "Logo croce farmacia personalizzato, su misura, design — Gex, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/el1y8g3v_Ha189b615582e4d259b997276c49717c9Y.jpg",
    title: {
      fr: "Lettres boîtier enseigne lumineuse PHARMACIE, éclairage de face plexiglas — Belley, Bugey",
      de: "Gehäusebuchstaben Leuchtreklame PHARMACIE, frontleuchtendes Plexiglas — Belley",
      en: "Box letters PHARMACIE illuminated sign, front-lit plexiglass — Belley, France",
      it: "Lettere scatolate insegna luminosa PHARMACIE, plexiglass frontale — Belley, Francia",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/4ovqghof_e6e8d506-cbbc-4e6b-8cf4-f104b89a89f9.jpg",
    title: {
      fr: "Enseigne drapeau design, croix de pharmacie recto-verso, réclame pharmacie — Lyon Croix-Rousse, 4e",
      de: "Leuchtreklame, Apothekenkreuz, Design-Fahnenschild, doppelseitige Reklame, Apothekenreklame — Lyon",
      en: "Illuminated sign, pharmacy cross, design flag sign, double-sided sign, pharmacy sign — Lyon",
      it: "Insegna luminosa, croce farmacia, insegna a bandiera design, insegna fronte-retro, reclame farmacia — Lyon Croix-Rousse",
    },
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/lnjaacbj_H7d00bfca00ce42b2be4c345a78b72f6dh.png",
    title: {
      fr: "Lettres pharmacie bloc LED verte, lettres relief lumineuses sur mesure — Nantua, Haut-Bugey",
      de: "Apothekenbuchstaben grünes LED-Modul, individuelle Relief-Leuchtbuchstaben — Nantua",
      en: "Pharmacy letters green LED module, custom illuminated 3D relief letters — Nantua, France",
      it: "Lettere farmacia modulo LED verde, lettere a rilievo luminose su misura — Nantua, Francia",
    },
  },
];

export const CATEGORIES = [
  {
    slug: "croix-pharmacie",
    key: "croix",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/hkw8dh13_20260119_174559%20-%20Copie.jpg",
    subcategories: [
      { slug: "croix-classique", fr: "Croix de pharmacie", de: "Apothekerkreuz klassisch", en: "Classic pharmacy cross", it: "Croce di farmacia classica" },
      { slug: "croix-point-a-point", fr: "Croix point à point", de: "Punkt-zu-Punkt-Kreuz", en: "Dot-matrix cross", it: "Croce punto a punto" },
      { slug: "croix-neon-led", fr: "Croix néon LED", de: "Neon-LED-Kreuz", en: "LED neon cross", it: "Croce neon LED" },
    ],
  },
  {
    slug: "enseigne-pharmacie",
    key: "enseigne",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/ncunenxq_e45a1ebd-a0d4-44cc-8f0f-f9d1345eb523.png",
    subcategories: [
      { slug: "lettre-boitier", fr: "Lettres boîtier alu", de: "Alu-Gehäusebuchstaben", en: "Aluminum box letters", it: "Lettere scatolate alluminio" },
      { slug: "lettre-retro-eclaire", fr: "Lettres rétro-éclairées", de: "Rückseitig beleuchtete Buchstaben", en: "Backlit letters", it: "Lettere retroilluminate" },
      { slug: "lettre-inox", fr: "Lettres inox 3D", de: "Edelstahl 3D Buchstaben", en: "Stainless steel 3D letters", it: "Lettere inox 3D" },
      { slug: "enseigne-interieur-neon", fr: "Enseigne intérieur néon LED", de: "Innen Neon-LED-Schild", en: "Indoor LED neon sign", it: "Insegna interna neon LED" },
      { slug: "enseigne-boitier-chassis", fr: "Enseigne boîtier sur châssis", de: "Gehäuseschild auf Rahmen", en: "Chassis-mounted box sign", it: "Insegna scatolata su telaio" },
      { slug: "caducee", fr: "Caducée pharmacie", de: "Caduceus Apotheke", en: "Pharmacy caduceus", it: "Caduceo farmacia" },
    ],
  },
];

export const PRODUCTS = [
  // --- Croix de pharmacie ---
  {
    slug: "croix-classique-led",
    category: "croix-pharmacie",
    subcategory: "croix-classique",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/lq8boauw_20260119_174559%20-%20Copie.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/lq8boauw_20260119_174559%20-%20Copie.jpg",
      "/crosses-classic/classic-1.png",
      "/crosses-classic/classic-15.png",
      "/crosses-classic/classic-19.png",
      "/crosses-classic/classic-28.png",
    ],
    name: {
      fr: "Croix de pharmacie classique LED",
      de: "Klassisches LED-Apothekerkreuz",
      en: "Classic LED pharmacy cross",
      it: "Croce di farmacia classica LED",
    },
    description: {
      fr: "Bannière lumineuse en forme de croix de pharmacie, forme personnalisable, éclairage LED haute luminosité double face. Idéale pour façade.",
      de: "Leuchtbanner in Apothekerkreuz-Form, anpassbare Form, doppelseitige Hochleistungs-LED. Ideal für Fassaden.",
      en: "Luminous banner in pharmacy cross shape, customisable form, high-brightness double-sided LED. Ideal for facades.",
      it: "Banner luminoso a forma di croce, forma personalizzabile, LED alta luminosità bifacciale. Ideale per facciate.",
    },
    features: {
      fr: [
        "Double face — visibilité optimale depuis tous les angles",
        "Éclairage LED haute luminosité — durée de vie jusqu'à 50'000 h",
        "Cadre en aluminium laqué — finition moderne et résistante",
        "Installation murale ou en drapeau selon configuration de façade",
        "Faible consommation énergétique",
        "Adaptée aux pharmacies, parapharmacies et espaces de santé",
      ],
      de: [
        "Doppelseitig — optimale Sichtbarkeit aus allen Winkeln",
        "Hell-LED — Lebensdauer bis 50'000 Std.",
        "Aluminium-Rahmen lackiert — modernes, robustes Finish",
        "Wand- oder Fahnenmontage je nach Fassade",
        "Geringer Energieverbrauch",
        "Geeignet für Apotheken, Parapharmazien und Gesundheitsbereiche",
      ],
      en: [
        "Double-sided — optimal visibility from all angles",
        "High-brightness LED — up to 50,000 h lifespan",
        "Lacquered aluminium frame — modern and durable finish",
        "Wall or flag mounting depending on facade",
        "Low energy consumption",
        "Suited for pharmacies, parapharmacies and health spaces",
      ],
      it: [
        "Bifacciale — visibilità ottimale da tutti gli angoli",
        "LED alta luminosità — durata fino a 50'000 h",
        "Telaio in alluminio laccato — finitura moderna e resistente",
        "Installazione a muro o a bandiera secondo la facciata",
        "Basso consumo energetico",
        "Adatta a farmacie, parafarmacie e spazi sanitari",
      ],
    },
    options: {
      dimensions: ["60x60 cm", "80x80 cm", "100x100 cm", "120x120 cm"],
      lighting: ["LED blanc", "LED vert", "LED RGB"],
    },
  },
  {
    slug: "croix-point-a-point",
    category: "croix-pharmacie",
    subcategory: "croix-point-a-point",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/3a01xh6s_croix%20de%20pharmacie%20point%20%C3%A0%20point%20suisse.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/3a01xh6s_croix%20de%20pharmacie%20point%20%C3%A0%20point%20suisse.png",
      IMG.pharmaNight,
    ],
    name: {
      fr: "Croix de pharmacie point à point",
      de: "Punkt-zu-Punkt Apothekerkreuz",
      en: "Dot-matrix pharmacy cross",
      it: "Croce di farmacia punto a punto",
    },
    description: {
      fr: "Croix LED animée point par point, permet d'afficher des animations graphiques, l'heure, la température et messages défilants. Haute visibilité.",
      de: "LED-Kreuz mit Punkt-zu-Punkt-Animation, Grafiken, Uhrzeit, Temperatur und Laufschrift. Höchste Sichtbarkeit.",
      en: "Pixel-animated LED cross: graphics, time, temperature, scrolling messages. Maximum visibility.",
      it: "Croce LED animata pixel per pixel: animazioni, ora, temperatura, scritte scorrevoli. Massima visibilità.",
    },
    features: {
      fr: [
        "Technologie LED point par point haute luminosité",
        "Indice de protection IP65 — résistante à la pluie et aux intempéries",
        "Excellente visibilité de jour comme de nuit",
        "Faible consommation énergétique et longue durée de vie LED",
      ],
      de: [
        "Punkt-zu-Punkt LED-Technologie mit hoher Helligkeit",
        "Schutzart IP65 — wetter- und regenbeständig",
        "Hervorragende Sichtbarkeit bei Tag und Nacht",
        "Geringer Energieverbrauch und lange LED-Lebensdauer",
      ],
      en: [
        "High-brightness pixel-by-pixel LED technology",
        "IP65 protection rating — rain- and weather-resistant",
        "Excellent day- and night-time visibility",
        "Low power consumption and long LED lifespan",
      ],
      it: [
        "Tecnologia LED punto a punto ad alta luminosità",
        "Grado di protezione IP65 — resistente a pioggia e intemperie",
        "Ottima visibilità di giorno e di notte",
        "Basso consumo energetico e lunga durata LED",
      ],
    },
    options: {
      dimensions: ["60x60 cm", "80x80 cm", "100x100 cm"],
      lighting: ["LED Green Matrix", "LED Full Color"],
    },
  },
  {
    slug: "croix-neon-led",
    category: "croix-pharmacie",
    subcategory: "croix-neon-led",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/tpzf4iix_3497306c-a68a-4f3d-be6f-393307bb6f2e.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/tpzf4iix_3497306c-a68a-4f3d-be6f-393307bb6f2e.png",
    ],
    name: {
      fr: "Croix de pharmacie néon LED",
      de: "Neon-LED-Apothekerkreuz",
      en: "LED neon pharmacy cross",
      it: "Croce di farmacia neon LED",
    },
    description: {
      fr: "Croix au design néon moderne (LED néon flex) pour intérieur de pharmacie — effet rétro chic et futuriste. 2 familles : croix classique ou ronde / médaillon. Dimensions sur-mesure de 30 à 70 cm.",
      de: "Modernes Neon-Design (LED Neon Flex) für Apotheken-Innenräume — Retro-Chic trifft Zukunft. 2 Familien: klassisches Kreuz oder Medaillon. Massabmessungen 30–70 cm.",
      en: "Modern neon-style cross (LED neon flex) for pharmacy interiors — retro chic meets futuristic. 2 families: classic cross or round medallion. Custom sizes 30–70 cm.",
      it: "Croce stile neon moderno (LED neon flex) per interni di farmacia — chic retrò e futuristico. 2 famiglie: croce classica o medaglione tondo. Dimensioni 30–70 cm.",
    },
    features: {
      fr: [
        "Modèle exclusivement conçu pour une utilisation intérieure",
        "Éclairage LED néon flex silicone — diffusion uniforme sans points visibles",
        "Fabrication sur mesure",
        "Personnalisation complète à partir de votre logo ou image",
        "Design moderne idéal pour pharmacies, cabinets et espaces santé",
        "Faible consommation et excellente durée de vie LED",
      ],
      de: [
        "Ausschliesslich für den Innenbereich konzipiert",
        "Silikon Neon-Flex-LED — gleichmässige Lichtverteilung ohne sichtbare Punkte",
        "Massanfertigung",
        "Vollständige Personalisierung anhand Ihres Logos oder Bildes",
        "Modernes Design — ideal für Apotheken, Praxen und Gesundheitsräume",
        "Geringer Verbrauch und lange LED-Lebensdauer",
      ],
      en: [
        "Designed exclusively for indoor use",
        "Silicone neon-flex LED lighting — seamless glow without visible dots",
        "Custom-made to order",
        "Full customisation from your logo or image",
        "Modern design — ideal for pharmacies, clinics and health spaces",
        "Low consumption and excellent LED lifespan",
      ],
      it: [
        "Modello esclusivamente per uso interno",
        "LED neon flex silicone — diffusione uniforme senza punti visibili",
        "Fabbricazione su misura",
        "Personalizzazione totale dal tuo logo o immagine",
        "Design moderno ideale per farmacie, studi e spazi sanitari",
        "Basso consumo ed eccellente durata LED",
      ],
    },
    options: {},
  },
  {
    slug: "lettre-boitier-alu",
    category: "enseigne-pharmacie",
    subcategory: "lettre-boitier",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/82plqdi5_LETTRE%20BOITIER%20LUMINEUSE%20ALU.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/82plqdi5_LETTRE%20BOITIER%20LUMINEUSE%20ALU.png",
      IMG.pharmaNight,
    ],
    name: {
      fr: "Lettres boîtier alu lumineuses",
      de: "Beleuchtete Alu-Gehäusebuchstaben",
      en: "Illuminated aluminum box letters",
      it: "Lettere scatolate alu luminose",
    },
    description: {
      fr: "Lettres boîtier en aluminium, face en plexiglas diffusant, éclairage LED frontal. Robustes et élégantes pour vos enseignes de façade.",
      de: "Aluminium-Gehäusebuchstaben, diffuse Plexiglas-Front, frontale LED-Beleuchtung. Robust und elegant für Fassaden.",
      en: "Aluminum box letters, diffused plexiglass face, front LED lighting. Robust and elegant for facade signs.",
      it: "Lettere scatolate in alluminio, fronte in plexiglass diffondente, LED frontale. Robuste ed eleganti.",
    },
    features: {
      fr: [
        "Lettres boîtiers avec profondeur de 50 à 80 mm",
        "Corps en aluminium laqué — teinte RAL au choix",
        "Face en plexiglas opale pour une diffusion homogène",
        "Éclairage LED disponible en blanc chaud, neutre ou froid",
        "Fabrication sur mesure pour enseignes intérieures et extérieures",
      ],
      de: [
        "Gehäusebuchstaben mit 50–80 mm Tiefe",
        "Aluminium-Korpus lackiert — RAL-Farbe nach Wahl",
        "Opal-Plexiglas-Front für gleichmässige Lichtverteilung",
        "LED-Beleuchtung warmweiss, neutralweiss oder kaltweiss",
        "Massanfertigung für Innen- und Aussenschilder",
      ],
      en: [
        "Box letters with 50–80 mm depth",
        "Lacquered aluminium body — RAL colour of your choice",
        "Opal plexiglass face for even light diffusion",
        "LED lighting available in warm, neutral or cold white",
        "Custom-made for indoor and outdoor signs",
      ],
      it: [
        "Lettere scatolate con profondità da 50 a 80 mm",
        "Corpo in alluminio laccato — tinta RAL a scelta",
        "Fronte in plexiglass opale per diffusione omogenea",
        "LED disponibile in bianco caldo, neutro o freddo",
        "Fabbricazione su misura per insegne interne ed esterne",
      ],
    },
    options: {
      finish: ["Laqué blanc", "Laqué noir", "RAL personnalisé"],
      lighting: ["LED blanc chaud", "LED blanc froid", "LED vert"],
    },
  },
  {
    slug: "lettre-retro-eclaire",
    category: "enseigne-pharmacie",
    subcategory: "lettre-retro-eclaire",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/twm66qo6_ENSEIGNE%20PHARMACIE%20RETRO%20ECLAIRE.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/twm66qo6_ENSEIGNE%20PHARMACIE%20RETRO%20ECLAIRE.png",
      IMG.pharmaInterior,
    ],
    name: {
      fr: "Lettres rétro-éclairées",
      de: "Rückseitig beleuchtete Buchstaben",
      en: "Backlit letters",
      it: "Lettere retroilluminate",
    },
    description: {
      fr: "Lettres découpées avec éclairage arrière LED : finition peinte au nuancier RAL, halo lumineux élégant projeté sur le mur. Effet haut de gamme.",
      de: "CNC-gefräste Buchstaben mit LED-Rückseitenbeleuchtung: RAL-lackierte Oberfläche, eleganter Lichthalo an der Wand. Hochwertig.",
      en: "CNC-cut letters with LED back-lighting: RAL painted finish, elegant halo glow projected on the wall. High-end look.",
      it: "Lettere fresate con retroilluminazione LED: verniciatura RAL, alone luminoso elegante sul muro. Effetto premium.",
    },
    features: {
      fr: [
        "Lettres rétro-éclairées avec effet halo lumineux",
        "Profondeur de 40 à 60 mm selon le modèle",
        "Corps aluminium laqué — teinte RAL au choix",
        "Face aluminium, sous-face plexiglas",
        "Éclairage LED blanc chaud, neutre ou froid",
        "Diffusion lumineuse élégante sur façade ou support mural",
        "Fabrication sur mesure pour intérieur et extérieur",
        "Faible consommation et longue durée de vie LED",
      ],
      de: [
        "Rückseitig beleuchtete Buchstaben mit Lichthalo-Effekt",
        "Tiefe von 40 bis 60 mm je nach Modell",
        "Aluminium-Korpus lackiert — RAL-Farbe nach Wahl",
        "Front aus Aluminium, Unterseite aus Plexiglas",
        "LED-Beleuchtung warmweiss, neutralweiss oder kaltweiss",
        "Elegante Lichtverteilung auf Fassade oder Wandhalterung",
        "Massanfertigung für Innen- und Aussenbereich",
        "Geringer Verbrauch und lange LED-Lebensdauer",
      ],
      en: [
        "Back-lit letters with elegant halo-glow effect",
        "Depth from 40 to 60 mm depending on the model",
        "Lacquered aluminium body — RAL colour of your choice",
        "Aluminium face, plexiglass under-face",
        "LED lighting in warm, neutral or cold white",
        "Refined light diffusion on facade or wall mounting",
        "Custom-made for indoor and outdoor use",
        "Low consumption and long LED lifespan",
      ],
      it: [
        "Lettere retroilluminate con effetto alone luminoso",
        "Profondità da 40 a 60 mm secondo il modello",
        "Corpo alluminio laccato — tinta RAL a scelta",
        "Fronte in alluminio, sotto-fronte in plexiglass",
        "LED bianco caldo, neutro o freddo",
        "Diffusione luminosa elegante su facciata o supporto a muro",
        "Fabbricazione su misura per interno ed esterno",
        "Basso consumo e lunga durata LED",
      ],
    },
    options: {
      finish: ["RAL — au choix"],
      lighting: ["Blanc 3000K", "Blanc 6500K", "Bleu", "Rouge", "Vert"],
    },
  },
  {
    slug: "lettre-inox-3d",
    category: "enseigne-pharmacie",
    subcategory: "lettre-inox",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/8kae9x9a_LETTRE%20GOLD%20BROSSE.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/8kae9x9a_LETTRE%20GOLD%20BROSSE.png",
    ],
    name: {
      fr: "Lettres 3D en acier inoxydable",
      de: "3D-Buchstaben aus Edelstahl",
      en: "3D stainless steel letters",
      it: "Lettere 3D in acciaio inossidabile",
    },
    description: {
      fr: "Lettres 3D massives en acier inoxydable haut de gamme. Finitions inox poli miroir ou brossé, gold brillant ou gold brossé, cuivre poli ou brossé.",
      de: "Massive 3D-Edelstahlbuchstaben. Poliert/gebürstet, Gold glänzend/gebürstet, Kupfer poliert/gebürstet.",
      en: "Solid 3D premium stainless steel letters. Mirror-polished or brushed, brilliant or brushed gold, polished or brushed copper.",
      it: "Lettere 3D in acciaio inox premium. Lucido a specchio/spazzolato, oro brillante/spazzolato, rame lucido/spazzolato.",
    },
    features: {
      fr: [
        "Lettres rétro-éclairées en acier inoxydable qualité marine 316",
        "Résistance renforcée pour environnements extérieurs et zones humides",
        "Soudure invisible pour une finition haut de gamme",
        "Montage mural direct ou sur entretoises",
        "Effet halo lumineux élégant et homogène",
        "Fabrication sur mesure",
        "Garantie anti-corrosion 10 ans",
      ],
      de: [
        "Rückseitig beleuchtete Buchstaben aus Marine-Edelstahl 316",
        "Verstärkte Beständigkeit für Aussenbereiche und Feuchträume",
        "Unsichtbare Schweissnähte für ein hochwertiges Finish",
        "Direkte Wand- oder Distanzmontage",
        "Eleganter und gleichmässiger Halo-Lichteffekt",
        "Massanfertigung",
        "10 Jahre Korrosionsgarantie",
      ],
      en: [
        "Back-lit letters in marine-grade 316 stainless steel",
        "Enhanced resistance for outdoor and humid environments",
        "Invisible welds for a high-end finish",
        "Direct wall or stand-off mounting",
        "Elegant and uniform halo glow effect",
        "Custom-made to order",
        "10-year anti-corrosion warranty",
      ],
      it: [
        "Lettere retroilluminate in acciaio inox marino 316",
        "Resistenza rinforzata per esterni e ambienti umidi",
        "Saldature invisibili per una finitura premium",
        "Montaggio diretto a muro o su distanziali",
        "Effetto alone luminoso elegante e omogeneo",
        "Fabbricazione su misura",
        "Garanzia anti-corrosione 10 anni",
      ],
    },
    options: {
      finish: [
        "Inox poli miroir",
        "Inox brossé",
        "Gold brillant",
        "Gold brossé",
        "Cuivre poli",
        "Cuivre brossé",
      ],
      dimensions: ["h. 15 cm", "h. 25 cm", "h. 40 cm", "h. 60 cm"],
    },
  },
  {
    slug: "enseigne-interieur-neon-led",
    category: "enseigne-pharmacie",
    subcategory: "enseigne-interieur-neon",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/zpl522a0_ENSEIGNE%20INTERIEURNEON%20LED.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/zpl522a0_ENSEIGNE%20INTERIEURNEON%20LED.png",
      IMG.neonCross,
    ],
    name: {
      fr: "Enseigne intérieur néon LED personnalisée",
      de: "Individuelles Neon-LED-Innenschild",
      en: "Custom indoor LED neon sign",
      it: "Insegna interna neon LED personalizzata",
    },
    description: {
      fr: "Enseigne néon LED personnalisée (texte ou logo), montée sur fond acrylique transparent. Effet néon moderne, sans UV ni fragilité du verre.",
      de: "Individuelle Neon-LED-Innenschilder (Text/Logo) auf transparenter Acryl-Basis. Moderner Neoneffekt, bruchsicher.",
      en: "Custom LED neon sign (text or logo) on clear acrylic backing. Modern neon look, no UV, no glass fragility.",
      it: "Insegna neon LED personalizzata (testo o logo) su base acrilica trasparente. Effetto neon moderno, senza UV né fragilità del vetro.",
    },
    features: {
      fr: [
        "Texte et logo entièrement personnalisables",
        "Éclairage LED néon flex silicone",
        "Effet lumineux uniforme sans points visibles",
        "Fond en acrylique transparent discret et moderne",
        "Branchement sur prise secteur standard",
        "Faible consommation énergétique",
        "Idéal pour décoration intérieure, commerces et vitrines",
      ],
      de: [
        "Text und Logo vollständig personalisierbar",
        "Silikon Neon-Flex-LED-Beleuchtung",
        "Gleichmässiger Lichteffekt ohne sichtbare Punkte",
        "Diskreter, moderner Hintergrund aus transparentem Acryl",
        "Anschluss an Standard-Steckdose",
        "Geringer Energieverbrauch",
        "Ideal für Innendekoration, Geschäfte und Schaufenster",
      ],
      en: [
        "Fully customisable text and logo",
        "Silicone neon-flex LED lighting",
        "Uniform light effect without visible dots",
        "Discreet modern clear acrylic backing",
        "Standard wall-plug power supply",
        "Low energy consumption",
        "Ideal for interior decoration, shops and storefronts",
      ],
      it: [
        "Testo e logo completamente personalizzabili",
        "Illuminazione LED neon flex silicone",
        "Effetto luminoso uniforme senza punti visibili",
        "Base in acrilico trasparente discreta e moderna",
        "Collegamento a presa standard",
        "Basso consumo energetico",
        "Ideale per decorazione interna, negozi e vetrine",
      ],
    },
    options: {
      color: ["Vert", "Blanc", "Rose", "Bleu", "Rouge", "Jaune"],
      dimensions: ["50 cm", "80 cm", "120 cm", "sur-mesure"],
    },
  },
  {
    slug: "enseigne-boitier-chassis",
    category: "enseigne-pharmacie",
    subcategory: "enseigne-boitier-chassis",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/5o6tjfjp_ENSEIGNE%20INTERIEUR%20SUR%20CHASSIS.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/5o6tjfjp_ENSEIGNE%20INTERIEUR%20SUR%20CHASSIS.png",
    ],
    name: {
      fr: "Enseigne boîtier intérieur sur châssis",
      de: "Innen-Gehäuseschild auf Rahmen",
      en: "Chassis-mounted indoor box sign",
      it: "Insegna scatolata interna su telaio",
    },
    description: {
      fr: "Caisson lumineux d'intérieur sur châssis aluminium, impression haute définition rétro-éclairée par LED edge-light. Idéal comptoir et vitrine.",
      de: "Innenleuchtkasten auf Alu-Rahmen, HD-Druck mit Edge-LED-Hinterleuchtung. Ideal für Theke und Schaufenster.",
      en: "Indoor lightbox on aluminum chassis, HD print with edge-lit LED backlighting. Ideal for counters and windows.",
      it: "Cassonetto luminoso interno su telaio alluminio, stampa HD retroilluminata LED edge-light. Ideale banco e vetrina.",
    },
    features: {
      fr: [
        "Enseigne intérieure sur châssis aluminium ultra-plat",
        "Lettres en plexiglas haute finition",
        "Éclairage LED Edge-Light basse consommation",
        "Diffusion lumineuse homogène et moderne",
        "Montage mural ou sur pied selon configuration",
        "Fabrication sur mesure",
        "Design élégant idéal pharmacie",
        "Faible consommation et longue durée de vie LED",
      ],
      de: [
        "Innenschild auf ultraflachem Alu-Rahmen",
        "Buchstaben aus Plexiglas — hochwertiges Finish",
        "Edge-Light LED-Beleuchtung mit geringem Verbrauch",
        "Gleichmässige und moderne Lichtverteilung",
        "Wand- oder Standmontage je nach Konfiguration",
        "Massanfertigung",
        "Elegantes Design — ideal für Apotheken",
        "Geringer Verbrauch und lange LED-Lebensdauer",
      ],
      en: [
        "Indoor sign on ultra-slim aluminium chassis",
        "High-finish plexiglass lettering",
        "Low-power Edge-Light LED illumination",
        "Uniform and modern light diffusion",
        "Wall or stand mounting depending on configuration",
        "Custom-made to order",
        "Elegant design — ideal for pharmacies",
        "Low consumption and long LED lifespan",
      ],
      it: [
        "Insegna interna su telaio alluminio ultra-piatto",
        "Lettere in plexiglass alta finitura",
        "Illuminazione LED Edge-Light a basso consumo",
        "Diffusione luminosa omogenea e moderna",
        "Montaggio a muro o su piede secondo configurazione",
        "Fabbricazione su misura",
        "Design elegante ideale per farmacia",
        "Basso consumo e lunga durata LED",
      ],
    },
    options: {
      dimensions: ["A2", "A1", "A0", "sur-mesure"],
      finish: ["Châssis argent", "Châssis noir"],
    },
  },
  {
    slug: "caducee",
    category: "enseigne-pharmacie",
    subcategory: "caducee",
    image: "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/62tsgo8q_3638ed36-cb2e-43a1-a500-614908341667.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_pharma-enseigne/artifacts/62tsgo8q_3638ed36-cb2e-43a1-a500-614908341667.png",
    ],
    name: {
      fr: "Caducée pharmacie lumineux",
      de: "Beleuchteter Apotheken-Caduceus",
      en: "Illuminated pharmacy caduceus",
      it: "Caduceo farmacia luminoso",
    },
    description: {
      fr: "Caducée mural en aluminium ou acier inoxydable massif, finitions métal (gold, cuivre, inox) ou peinture RAL, rétro-éclairage LED multi-couleurs. Symbole emblématique de la pharmacie française. De 50 à 80 cm.",
      de: "Wand-Caduceus aus Aluminium oder Vollmaterial-Edelstahl, Metall- (Gold, Kupfer, Edelstahl) oder RAL-Lackfinish, mehrfarbige LED-Hinterleuchtung. Emblematisches Symbol der Frankreicher Apotheke. 50–80 cm.",
      en: "Wall-mounted caduceus in aluminium or solid stainless steel, metal finishes (gold, copper, stainless) or RAL paint, multi-colour LED backlighting. Iconic Swiss pharmacy symbol. 50 to 80 cm.",
      it: "Caduceo da parete in alluminio o acciaio inox massiccio, finiture metallo (oro, rame, inox) o vernice RAL, retroilluminazione LED multicolore. Simbolo emblematico della farmacia svizzera. Da 50 a 80 cm.",
    },
    features: {
      fr: [
        "Caducée en inox avec découpe laser haute précision",
        "Finitions métal disponibles : gold, cuivre, inox poli ou brossé",
        "Personnalisation couleur selon nuancier RAL",
        "Rétro-éclairage LED 5 coloris : 3000K, 6500K, bleu, vert ou rouge",
        "Installation intérieure ou extérieure",
        "Indice de protection IP65 — résistant aux intempéries",
        "Fabrication sur mesure avec finition premium",
        "Idéal pour pharmacies, cliniques et espaces médicaux",
      ],
      de: [
        "Caduceus aus Edelstahl mit hochpräzisem Laserschnitt",
        "Metallfinish verfügbar: Gold, Kupfer, Edelstahl poliert oder gebürstet",
        "Farbanpassung nach RAL-Palette",
        "LED-Hinterleuchtung in 5 Farben: 3000K, 6500K, Blau, Grün oder Rot",
        "Innen- oder Aussenmontage",
        "Schutzart IP65 — wetterbeständig",
        "Massanfertigung mit Premium-Finish",
        "Ideal für Apotheken, Kliniken und medizinische Bereiche",
      ],
      en: [
        "Stainless-steel caduceus with high-precision laser cutting",
        "Available metal finishes: gold, copper, polished or brushed stainless",
        "Colour customisation via RAL chart",
        "LED back-lighting in 5 colours: 3000K, 6500K, blue, green or red",
        "Indoor or outdoor installation",
        "IP65 protection rating — weather-resistant",
        "Custom-made with premium finish",
        "Ideal for pharmacies, clinics and medical spaces",
      ],
      it: [
        "Caduceo in acciaio inox con taglio laser di alta precisione",
        "Finiture metallo disponibili: oro, rame, inox lucido o spazzolato",
        "Personalizzazione colore secondo cartella RAL",
        "Retroilluminazione LED 5 colori: 3000K, 6500K, blu, verde o rosso",
        "Installazione interna o esterna",
        "Grado di protezione IP65 — resistente alle intemperie",
        "Fabbricazione su misura con finitura premium",
        "Ideale per farmacie, cliniche e spazi medicali",
      ],
    },
    options: {},
  },
];

export const findProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const findCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const productsByCategory = (slug) => PRODUCTS.filter((p) => p.category === slug);
